export type LegalMap = {
  [key: string]: {
    annotation: number;
    text: string;
    speedClaim?: string;
  };
};

export type Legal = {
  legalMap?: LegalMap;
  activeLegal?: string[];
};

// Redux
export enum ActionTypes {
  SET_LEGAL_MAP = "legal/map/set",
  ADD_ACTIVE_LEGAL = "legal/active/add",
  RESET_ACTIVE_LEGAL = "legal/active/reset",
  ADD_VIEWED_PRODUCT = "legal/viewed-product/add",
  RESET_VIEWED_PRODUCTS = "legal/viewed-products/reset",
}

export interface LegalAction {
  type: ActionTypes.SET_LEGAL_MAP;
  legalMap: LegalMap;
}

export interface ActiveLegalAction {
  type: ActionTypes.ADD_ACTIVE_LEGAL;
  activeLegal: string[];
}

export interface ResetLegalAction {
  type: ActionTypes.RESET_ACTIVE_LEGAL;
}

export interface ViewedProductAction {
  type: ActionTypes.ADD_VIEWED_PRODUCT;
  productId: string;
}

export interface ResetViewedProductsAction {
  type: ActionTypes.RESET_VIEWED_PRODUCTS;
}

export type Actions =
  | LegalAction
  | ActiveLegalAction
  | ResetLegalAction
  | ViewedProductAction
  | ResetViewedProductsAction;
